<template>

  <b-row>
    
    <b-col>
      <b-card
        no-body
        :class="{ open: visibleBody }"
      >
        <b-card-header
          :class="{ collapsed: !visibleBody }"
          :aria-expanded="visibleBody ? 'true' : 'false'"
          role="tab"
          data-toggle="collapse"
          @click="() => visibleBody = !visibleBody"
          style="padding: 1rem;background-color: #0080C9; color: white; font:45px; padding:15px;"
        >
          <span class="lead collapse-title">
            <strong>ANAMNESIS</strong>
          </span>
          <i
            :class="
              visibleBody
                ? 'fas fa-chevron-up'
                : 'fas fa-chevron-down'
            "
          />
        </b-card-header>
        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >
          <b-card-body style="padding: 10px">
            <div class="col-md-12">

              <b-row>
                <b-col>
                  <b-card
                    style="margin:0;border:1px solid #2980b9 ;padding:0 10px; cursor: pointer"
                    no-body
                    :class="{ 'open': visibleBodyMotivo }"
                  >
                    <b-card-header
                      style="color: black; font:45px; padding: 0 1px"
                      :class="{ 'collapsed': !visibleBodyMotivo }"
                      :aria-expanded="visibleBodyMotivo ? 'true' : 'false'"
                      role="tab"
                      data-toggle="collapse"
                      @click="onVisibleBody(!visibleBodyMotivo)"
                    >
                      <span class="lead collapse-title">
                        <strong>MOTIVO DE CONSULTA </strong>
                      </span>
                      <i :class="visibleBodyMotivo ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
                    </b-card-header>
                    <b-collapse
                      v-model="visibleBodyMotivo"
                      role="tabpanel"
                    >
                      <b-card-body style="padding: 1.5rem">

                        <div>
                          <label class="mt-2">Motivo de consulta</label>
                          <b-form-textarea
                            v-model="motivoConsulta"
                            placeholder="Describa el motivo de la consulta..."
                            rows="3"
                            
                            no-resize
                          />
                        </div>

                        <div class="my-2"> 
                          
                        </div>

                        <b-form-group  class = "mt-1" >
                          <b-button 
                            @click = "copyAS400('motivo')" 
                            variant = "info"
                          >
                            AS400  <i class="fas fa-copy"/>
                          </b-button>
                        </b-form-group>

                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </b-col>
              </b-row>
           
              <SemiologiasMain/>
              
              <AntecedentesPersonales :optionsOdontologia = "optionsOdontologia" :idPaciente = "idPaciente" :isEditar="isEditar"/>
              <AntecedentesFamiliares :idPaciente = "idPaciente" :isEditar="isEditar"/>

              <b-row>
                <b-col>
                  <b-card
                    style="margin:0;border:1px solid #2980b9;padding:0 10px"
                    no-body
                    :class="{ 'open': visibleBodyProblema }"
                  >
                    <b-card-header
                      :class="{ 'collapsed': !visibleBodyProblema }"
                      :aria-expanded="visibleBodyProblema ? 'true' : 'false'"
                      role="tab"
                      data-toggle="collapse"
                      @click="onVisibleBodyProblema(!visibleBodyProblema)"
                      style="color: black; font:45px; padding: 0 1px; cursor: pointer;"
                    >
                      

                      <span class="lead collapse-title">
                        <strong>PROBLEMA ACTUAL</strong>
                      </span>

                      <i :class="visibleBodyProblema ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" />
                    </b-card-header>

                    <b-collapse
                      v-model="visibleBodyProblema"
                      role="tabpanel"
                    >
                      <b-card-body 
                        style="padding: 1.5rem"
                      >
                        <b-form-group style="margin:0" label="Escribir el problema actual: ">
                          <b-form-textarea
                            v-model="problemaActual"
                            placeholder="Describa el problema actual"
                            rows="12"
                          />
                        </b-form-group>

                        <b-form-group  class = "mt-1" >
                          <b-button 
                            @click = "copyAS400('problema')" 
                            variant = "info"
                          >
                            AS400  <i class="fas fa-copy"/>
                          </b-button>
                        </b-form-group>

                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </b-col>
              </b-row>

              <RevisionOrganosSistemas v-if="!esOdontologia"/>
              
              <ExamenFisico v-if="!esOdontologia"/>

              <AtencionDiagnosticos/>
             
              <b-row>
                <b-col>
                  <b-card
                    style="margin:0;border:1px solid #2980b9;padding:0 10px"
                    no-body
                    :class="{ 'open': visibleBodyPlanTratamiento }"
                  >
                    <b-card-header
                      style="color: black; font:45px; padding: 0 1px; cursor: pointer"
                      :class="{ 'collapsed': !visibleBodyPlanTratamiento }"
                      :aria-expanded="visibleBodyPlanTratamiento ? 'true' : 'false'"
                      role="tab"
                      data-toggle="collapse"
                      @click="onVisibleBodyPlanTratamiento(!visibleBodyPlanTratamiento)"
                    >
                      <span class="lead collapse-title">
                        <strong>PLAN DE TRATAMIENTO </strong>
                      </span>
                      <i :class="visibleBodyPlanTratamiento ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
                    </b-card-header>

                    <b-collapse
                      v-model="visibleBodyPlanTratamiento"
                      role="tabpanel"
                    >
                      <b-card-body style="padding: 1.5rem">
                        <b-form-group style="margin:0" label="Escribir el plan tratamiento: ">
                          <b-form-textarea
                            v-model="planTratamiento"
                            placeholder="Describa el plan tratamiento"
                            rows="3"
                            no-resize
                          />
                        </b-form-group>
                        <b-form-group  class = "mt-1" >
                          <b-button  @click = "copyAS400('plan')" variant = "info">
                            AS400  <i class="fas fa-copy"/>
                          </b-button>
                        </b-form-group>
                      </b-card-body>
                    </b-collapse>
                    
                  </b-card>
                </b-col>
              </b-row>
              
              <TipoVez/>

            </div>
          </b-card-body>

        </b-collapse>
      </b-card>
    </b-col>
  </b-row>
  
</template>

<script>
import { mapState } from "vuex";
import { ESPECIALIDAD } from '@/shared/constants';

import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import { copyText } from "@/shared/helpers";
import {
  ProblemaActual, AntecedentesPersonales, AntecedentesFamiliares,
  MotivoConsulta, 
} from '@/views/citas/components';

import { ExamenFisico, RevisionOrganosSistemas, AtencionDiagnosticos } from '@/views/atencionCita/components';

import SemiologiasMain         from '@/views/atencionCita/components/Anamnesis/Semiologias/SemiologiasMain.vue';
import TipoVez from './components/TipoVez/TipoVez.vue';


export default {

  name: 'CrearAnamnesis',

  components: {
    ProblemaActual,
    AntecedentesPersonales, 
    AntecedentesFamiliares,
    MotivoConsulta,  
    TipoVez, 
    ExamenFisico,
    RevisionOrganosSistemas,
    AtencionDiagnosticos, 
    SemiologiasMain,
  
  },

  props: {

    dataAten: {
      type: [String, Number, Boolean, Object, Array, Function],
      default: 0 
    },
    idPaciente: {
      type: [String, Number, Boolean, Object, Array, Function],
      default: 0 
    },


  },
  data() {
    return {
      optionsOdontologia:null,
      isEditar:true,
      dataPsico:null,
      verTodo: false,
      idpaciente: null,
      motivoConsulta:null,
      visibleBodyProblema :false,
      visibleBodyPlanTratamiento :false,
      problemaActual : null,
      planTratamiento : null,
      visibleBody:true,
      visibleBodyMotivo: false,
      visibleBodyOdontograma:false,

      dataSemiologia: null
    };
  },
  
  created(){
    this.loadData();
  },

  
  
  methods: {
      esOdontologia(){
      if(this.codEsp === '0000000134') {return true}
      else {return false}
    },

    loadData(){
      const dataAtencion = this.dataAten;

      if(dataAtencion?.anamnesisSet ){
        this.motivoConsulta  = dataAtencion?.anamnesisSet[0]?.motivoConsulta
        this.problemaActual  = dataAtencion?.anamnesisSet[0]?.problemaActual
        this.planTratamiento = dataAtencion?.anamnesisSet[0]?.ptratamiento
      }

    },


    onVisibleBody(value) {
      this.visibleBodyMotivo = value;
    },
  
    onVisibleBodyProblema(value) {
      this.visibleBodyProblema = value;
    },
    onVisibleBodyPlanTratamiento(value) {
      this.visibleBodyPlanTratamiento = value;
    },

    copyAS400(item){
      if(item === 'motivo'){
        copyText(this.motivoConsulta);
      }
      if(item === 'problema'){
        copyText(this.problemaActual);
      }
      if(item === 'plan'){
        copyText(this.planTratamiento);
      }
    },

    

    resetDatos() {
      this.$store.commit("resetAnamnesis");
    },

  },


  computed: {
    ...mapState({
      codEsp          : state => state.atencionCita.dataCita?.doctor.especialidad.codEsp,
      stEspecialidad  : state => state.atencionCita.dataCita?.doctor.especialidad,
      stSemFisiatrica : state => state.atencionCita.semiologias?.semFisiatrica,
      stDataDoctor    : state => state.atencionCita.dataCita?.doctor,
    }),

    esPediatria() {
      return this.stDataDoctor?.especialidad?.codEsp === ESPECIALIDAD.PEDIATRA;
    },
     esOdontologia() {
      return this.stDataDoctor?.especialidad?.codEsp === ESPECIALIDAD.ODONTOLOGIA;
    },
  },



  watch :{
     esOdontologia:{
      deep:true,
      inmediate:true,
      handler(){
        let optionsOdontologia = [
  { "text": "ALERGIA MEDICAMENTO", "value": "alergia_medicamento" },
  { "text": "ALERGIA ANESTESIA", "value": "alergia_anestesia" },
  { "text": "HEMORRAGIAS", "value": "hemorragias" },
  { "text": "VIH/SIDA", "value": "vih_sida" },
  { "text": "TUBERCULOSIS", "value": "tuberculosis" },
  { "text": "ASMA", "value": "asma" },
  { "text": "DIABETES", "value": "diabetes" },
  { "text": "HIPERTENSIÓN", "value": "hipertension" },
  { "text": "ENF. CARDIACA", "value": "enf_cardiaca" },
 { "text": "OTROS", "value": "otros" },]
        this.optionsOdontologia = [...optionsOdontologia];
      }
    },

    dataAten:{
      deep:true,
      inmediate:true,
      handler(){
        
        this.loadData();
      }
    },

    motivoConsulta:{
      deep:true,
      handler(newValue){
        if(newValue ){
          try {
            this.$store.commit("setMotivoConsulta", newValue);
          } catch(error) {
            console.log("ocurrio un error", error)
          }
          
        }
        
      }
    },

    problemaActual:{
      deep:true,
      handler(newValue){
        if(newValue ){
          try {
            this.$store.commit("setProblemaActual", newValue );
          } catch(error) {
            console.log("ocurrio un error", error)
          }
          
        }
        
      }
    },

    planTratamiento:{
      deep:true,
      handler(newValue){
        if(newValue ){
          try {
            this.$store.commit("setPlanTratamiento", newValue)
          } catch(error) {
            console.log("ocurrio un error", error)
          }
          
        }
        
      }
    }
  }
};

</script>
